import React from "react";
import { HowSlideBase } from 'src/pages/how/how-slide-base/HowSlideBase';
import "./HowSlide2.scss";
import documentAnchors from './anchor-data/document';

export class HowSlide2 extends HowSlideBase {
  render() {
    return this.createSlide({
      step: 2,
      title: 'Define',
      content: <>
        <p>Design Thinking is <b>95% about the problem</b>.</p>
        <p>Define what problems we’re going to solve. If you try to prescribe a cure before diagnosing the sickness, you’ll cause more harm than good.</p>
        <p>Falling in love with a solution means you’ll stick with a bad idea against the evidence.</p>
      </>,
      image: './assets/how/image-step-2.svg',
      fills: [
        { anchors: documentAnchors, x: 150, y: 40 },
        { anchors: documentAnchors, x: 50, y: 145 },
        { anchors: documentAnchors, x: 155, y: 150 },
        { anchors: documentAnchors, x: 255, y: 148 },
      ],
      fillDimensions: {
        x: 10,
        y: 17,
        width: 370,
        height: 300,
      }
    });
  }
}
